"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = PlennyColor;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function PlennyColor(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    id: "Shoppa",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("style", {
    dangerouslySetInnerHTML: {
      __html: ".cls-1{fill:#d9d9d9;}.cls-2{fill:#f5a56d;}.cls-3{fill:#e6e6e6;}.cls-4{fill:#f4cd78;}"
    }
  })), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Plenny_color"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "original"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    className: "cls-1",
    x: "50.45",
    y: "22.4",
    width: "0.56",
    height: "9.6"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-2",
    d: "M53.45,21.37a2.68,2.68,0,1,1-2.68-2.67,2.68,2.68,0,0,1,2.68,2.67"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-1",
    d: "M60.44,33c0-2.62-4.33-4.75-9.67-4.75S41.1,30.41,41.1,33Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-1",
    d: "M82.19,45.23c4.31,0,7.81,4.46,7.81,10s-3.5,9.94-7.81,9.94"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-1",
    d: "M17.81,45.23c-4.31,0-7.81,4.46-7.81,10s3.5,9.94,7.81,9.94"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-3",
    d: "M49.94,81.3h-.69c-2.09,0-6.11-.14-9.16-.43-6.91-.65-14.33-2.09-20.42-6.05a8.94,8.94,0,0,1-2.39-2.13A11.91,11.91,0,0,1,15,66.08c-.41-7.68-.36-9.55-.36-9.55v-2S14.62,52.68,15,45a11.93,11.93,0,0,1,2.25-6.61,9.11,9.11,0,0,1,2.39-2.13c6.09-3.95,13.51-5.4,20.42-6,3-.29,6-.3,9.2-.29h1.8c3.21,0,6.15,0,9.2.29,6.91.65,14.33,2.1,20.42,6a9.11,9.11,0,0,1,2.39,2.13A12,12,0,0,1,85.34,45c.42,7.68.37,9.55.37,9.55v2s.05,1.87-.37,9.55a12,12,0,0,1-2.24,6.61,8.94,8.94,0,0,1-2.39,2.13c-6.09,4-13.51,5.4-20.42,6.05-3,.29-7.07.48-9.16.43H49.94Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-4",
    d: "M50,76.89h-.57c-1.73,0-5.06-.11-7.59-.35C36.1,76,30,74.8,24.91,71.53a7.57,7.57,0,0,1-2-1.77,9.88,9.88,0,0,1-1.86-5.48c-.35-6.36-.31-7.91-.31-7.91V54.73s0-1.55.31-7.91a9.82,9.82,0,0,1,1.86-5.47,7.23,7.23,0,0,1,2-1.77c5-3.27,11.19-4.47,16.91-5,2.53-.24,5-.25,7.62-.24h1.5a76,76,0,0,1,7.61.24c5.73.54,11.87,1.74,16.92,5a7.23,7.23,0,0,1,2,1.77,9.9,9.9,0,0,1,1.86,5.47c.34,6.36.31,7.91.31,7.91v1.64s0,1.55-.31,7.91a10,10,0,0,1-1.86,5.48,7.57,7.57,0,0,1-2,1.77c-5,3.27-11.19,4.46-16.92,5-2.52.24-5.85.39-7.58.35H50Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-2",
    d: "M65.23,53.58c0,3.43-2,6.22-4.38,6.22S56.47,57,56.47,53.58s2-6.23,4.38-6.23,4.38,2.79,4.38,6.23"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-2",
    d: "M44.3,53.58c0,3.43-2,6.22-4.38,6.22S35.53,57,35.53,53.58s2-6.23,4.39-6.23,4.38,2.79,4.38,6.23"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-2",
    d: "M68,45.4s-3.62-2.7-10.13-1.52c0,0,6.9-4.07,10.13,1.52"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-2",
    d: "M46.53,65.32H55s.44,5.12-4.23,5.12-4.23-5.12-4.23-5.12"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-2",
    d: "M33.3,45s3.83-2.4,10.23-.71c0,0-6.56-4.6-10.23.71"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-4",
    d: "M42.42,50.54c0,.76-.44,1.38-1,1.38s-1-.62-1-1.38.44-1.38,1-1.38,1,.62,1,1.38"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-4",
    d: "M63.57,50.54c0,.76-.43,1.38-1,1.38s-1-.62-1-1.38.43-1.38,1-1.38,1,.62,1,1.38"
  }))));
}